// Simple Web Audio API sound generator — no external files needed.
let ctx = null;

function getCtx() {
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch { return null; }
  }
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function beep(freq, duration = 0.15, type = "sine", gain = 0.15, when = 0) {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, c.currentTime + when);
  g.gain.setValueAtTime(0.0001, c.currentTime + when);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + when + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + when + duration);
  o.connect(g); g.connect(c.destination);
  o.start(c.currentTime + when);
  o.stop(c.currentTime + when + duration + 0.02);
}

function chord(notes, duration = 0.35) {
  notes.forEach((n, i) => beep(n, duration, "sine", 0.12, i * 0.05));
}

const enabledKey = "iq_sound_enabled";
export const soundsEnabled = () => localStorage.getItem(enabledKey) !== "false";
export const setSoundsEnabled = (v) => localStorage.setItem(enabledKey, v ? "true" : "false");

export function playTradeOpen() {
  if (!soundsEnabled()) return;
  beep(880, 0.10, "sine", 0.18);
}
export function playTradeWin() {
  if (!soundsEnabled()) return;
  chord([523.25, 659.25, 783.99], 0.4); // C major triad
}
export function playTradeLose() {
  if (!soundsEnabled()) return;
  chord([440, 415.30, 349.23], 0.35); // descending
}
export function playTick() {
  if (!soundsEnabled()) return;
  beep(1200, 0.03, "square", 0.05);
}
